import { Meter } from "@nymbl/nos2-rules";
import type { PlanStatus } from "@/lib/time/rules";

/**
 * "9 of 40 hrs" with a thin bar. Billable work with no guidance reads a muted "No guidance" (no
 * bar, no alert); other work with no guidance shows nothing.
 */
export function PlanBar({ plan }: { plan: PlanStatus }) {
  if (plan.state === "no-plan") {
    return <div className="text-xs text-muted-foreground">No guidance</div>;
  }
  if (plan.label === null) return null;
  return (
    <div className="flex items-center gap-2">
      <Meter
        ratio={plan.state === "over" || plan.state === "blocked" ? 1.01 : plan.ratio}
        label={plan.label}
        overTone={plan.state === "over" ? "warning" : "danger"}
        hideLabel
        className="w-20"
      />
      <span className="text-xs text-muted-foreground">{plan.label}</span>
    </div>
  );
}
